import { Route } from '@angular/router';
import { RoutingID } from '../../sb-routing-enum';
import { SbIcons } from '@ngx-seatback/icons';
import { WebSettingsComponent } from '../../../pages/client/settings/web-settings.component';

export const clientSettings: Route = {
  path: 'settings',
  component: WebSettingsComponent,
  title: 'nav.client.settings',
  data: {
    icon: SbIcons.companyClient,
    breadcrumb: 'nav.client.settings',
    id: RoutingID.settings,
  },
};
